export default __webpack_public_path__ + "images/weekly-schedule/weekly-charac-5254bd7d0d685164c8a5f90a9f2d7874.svg";